module.exports = __webpack_public_path__ + "static/media/icon-modal-arrow-left-light.b2628d6c.svg";